import { Transform } from 'class-transformer';

import { dateTransform } from '../utils/helper';
import { InsModDate } from './date.model';

export class Veicolo extends InsModDate {
	id?: number;
	plate?: string;
	model?: string;
	code?: string;
	yearreg?: number;
	cylinder?: number;
	fueltype?: string; // lista vehicle.fuel.type
	type?: string; // lista vehicle.type
	odometer?: number;
	@Transform(dateTransform)
	odolastdate?: Date;
	hp?: string;
	hqid?: number;

	setFuelType(event: string) {
		this.fueltype = event;
	}

	setType(event: string) {
		this.type = event;
	}

	get fullname(): string {
		return `${this.model} - ${this.plate}`;
	}
}

export function veicolo() {
	return Veicolo;
}